export enum ModalInfoType {
    SuccessRefinancing = 'successRefinancing', // Успешное рефинансирование;
    FailedRefinancing = 'failedRefinancing', // Заём не рефинансирован
    FailedCardCheck = 'failedCardCheck',  // Ошибка проверки карты
    WorkSalaryChanged = 'workSalaryChanged', // Изменение суммы дохода
}
  